import { addCollection } from '@iconify/react';
import logos from '@iconify-json/logos/icons.json';

let registered = false;

/** Bundle Iconify `logos` set once (official brand SVGs, offline). */
export function ensureLogosIconifyCollection() {
  if (registered) return;
  addCollection(logos);
  registered = true;
}
